module.exports = __webpack_public_path__ + "static/media/background-MAGENTA@2x-80.e42c4ac2.jpg";